module.exports = __webpack_public_path__ + "static/media/red-trash.7f53c149.svg";